module.exports = __webpack_public_path__ + "img/02-icon.dabbbf14.png";